export function useAtendimentoTag(atendimento) {
  if (atendimento === 'orcamento') {
    return 'Orçamento'
  }
  if (atendimento === 'avulso') {
    return 'Avulso'
  }
  return 'Normal'
}
